<template>

  <div>
    <div class="mainArea">
      <h1>Merkliste</h1>
      <div class="projectlist">
        <div class="projectlist-item" @click="openPost(reminder['.key'],reminder.position)" v-for="(reminder, index) in userReminder()" v-bind:key="index" v-bind:class="{ 'prio2':(reminder.priority === '2'), 'prio1':(reminder.priority === '1') }">
          <div class="projectlist-item-remove" @click="deleteReminder(reminder['.key'])" v-on:click.stop>
            <svgicon :icon="'delete'"  width="24" height="24" color="#334274"></svgicon>
          </div>
          <div class="projectlist-item-info">
             <h6>{{reminder.title}} <span>&raquo;</span></h6>
            <span><svgicon :icon="reminder.icon"  width="24" height="24" color="#334274"></svgicon>
            {{reminder.created|formatDate}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import firebase from 'firebase/app'
import _ from 'lodash'

var db = firebase.database()
var usersRef = db.ref('users')
var postsRef = db.ref('posts')

export default {
  name: 'Reminder',
  data () {
    return {
      currentUser: firebase.auth().currentUser.uid
    }
  },
  methods: {
    userReminder () {
      if (this.userData !== undefined) {
        let dataPosts = this.posts // eslint-disable-line
        let self = this
        dataPosts = _.filter(dataPosts, function (v) { return self.reminderItems[v['.key']] })
        // dataPosts = _.orderBy(dataPosts, ['added'], ['desc'])
        return dataPosts
      }
    },
    openPost (key, position) {
      this.$router.push({name: 'Map', params: {post: key, position: position}})
    },
    deleteReminder (key) {
      var r = confirm('Möchten Sie diesen Beirag wirklich von Ihrer Merkliste entfernen?')
      if (r === true) {
        usersRef.child(this.currentUser).child('reminder').child(key).remove()
      }
    }
  },
  firebase () {
    return {
      userData: usersRef.child(this.currentUser).child('reminder'),
      reminderItems: {
        source: usersRef.child(this.currentUser).child('reminder'),
        asObject: true
      },
      posts: postsRef
    }
  }
}
</script>

<style lang="scss">

  .projectlist {

      display: flex;
      // justify-content: space-between;
      // flex-direction: row;
      flex-wrap: wrap;
      max-width: 100%;
      margin-left: -12px;
      margin-right: -12px;
      // wdith: 960px;

  }

  .projectlist-item-remove {
    width: 24px;
    height: 24px;
    position: absolute;
    right: 20px;
    top: 15px;
    svg path {
      fill: $color-grey;
    }
    opacity: 0.5;
    &:hover {
      opacity: 1;
    }
  }

  .projectlist-item {

    position: relative;
    z-index: 1;
    width: 300px;
    max-width: calc((100% / 3) - 25px);
    @media screen and (min-width:1280px) {
      max-width: calc((100% / 4) - 25px);
    }
    background: #fff;
    box-sizing: border-box;
    padding: 20px 20px 15px;
    box-shadow: 0 2px 5px 0 rgba($color-text,0.1);
    height: 200px;
    color: $color-action;
    margin-top: 25px;
    user-select: none;

    &.prio1 {
      border-bottom: 6px solid rgba($color-error, 1);
    }

    &.prio2 {
      border-bottom: 6px solid rgba($color-warn, 1);
    }

    &.greyout {
      background: rgba(#fff, 0.25);
      box-shadow: 0 2px 5px 0 rgba($color-text,0.025);
      .projectlist-item-info > span {
        opacity: 0.25;
      }
      .project-list-item-connections {
        opacity: 0.25;
      }
      h6 {
        opacity: 0.4;
      }
      &.prio1 {
        border-bottom: 6px solid rgba($color-error, 0.15);
      }

      &.prio2 {
        border-bottom: 6px solid rgba($color-warn, 0.15);
      }
    }

    &:not(.prio1):not(.prio2) {
      border-bottom: 6px solid transparent;
    }

    h6 span {
      font-weight: 400;
    }

    margin-left: 12.5px;
    margin-right: 12.5px;

    .projectlist-item-info {
        position: absolute;
        bottom: 15px;
        left: 20px;
        right: 20px;
        color: $color-grey;
        font-size: $font-size-small;
        svg {
          margin-top: -3px;
          margin-left: -6px;
          path {
            fill: rgba($color-action, 0.25);
          }
        }
        & > span {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          display:block;
          width: 100%;
          max-width: 100%;
        }
    }
    &:hover {
      cursor: pointer;
    }

   h6 {
    font-family: 'Dosis', sans-serif;
    font-size: $font-size-default;
    line-height: 1.4em;
    hyphens: auto;
    color: $color-action;
    margin-bottom: 2.5px;
    text-align: left;
   }

    &.--addnew {
      box-shadow: none;
      background: transparent;
      border: 1px solid rgba($color-action, 0.1);
      text-align: center;
      color: rbga($color-action, 0.2) !important;
      place-items: center center;
    }

  }

  .projectlist-item-add {
    background: transparent !important;
    box-shadow: none !important;
    border: 1px dashed rgba($color-action, 0.25);
    border-bottom: 1px dashed rgba($color-action, 0.25) !important;
    text-align: center;
    line-height: 160px;
    svg {
      opacity: 0.5;
    }
    &:hover {
      svg {
        opacity: 1;
      }
    }
    &.disabled {
      svg {
        opacity: 0.1 !important;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Reminder.vue